import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

interface DialogData {
  id: string;
  titulo: string;
  mensagem: string;
  aberto: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private dialogs: Map<string, DialogData> = new Map();
  private onCloseSubject = new Subject<string>(); // Emissor do ID ao fechar

  onClose$ = this.onCloseSubject.asObservable(); // Observable para ouvir fechamentos

  abrirDialog(id: string, titulo: string, mensagem: string) {
    this.dialogs.set(id, { id, titulo, mensagem, aberto: true });
  }

  fecharDialog(id: string) {
    if (this.dialogs.has(id)) {
      this.dialogs.set(id, { ...this.dialogs.get(id)!, aberto: false });
      this.onCloseSubject.next(id); // Emite o ID do diálogo fechado
    }
  }

  getDialog(id: string) {
    return this.dialogs.get(id);
  }
}
